<template>
  <v-card class="card">
    <v-card-text class="pa-2">
      <pie-chart :data="items" legend="right" :donut="true" label="Total Inspections Completed Per Venue"></pie-chart>
    </v-card-text>
  </v-card>
</template>

<script>
  import JWT from "jsonwebtoken";

  export default {
    data() {
      return {
        items: {
          'USA': 90,
          'China': 70,
          'Russia': 40,
          'Germany': 30,
          'United Kingdom': 35,
          'Turkey': 22
        },
        customerItems: [],
        selectedCustomer: null,
        venueItems: [],
        NumberOfCompletedTasksPerVenue: [],
      }
    },
    mounted() {
      let self = this;

      self.SupervisorCompletedTasks();
    },
    methods: {
      SupervisorCompletedTasks() {
        let self = this;

        self.NumberOfCompletedTasksPerVenue = [];
        var inspectionCompletedCount = 0;
        self.get(`SupervisorInspectionTX/GetComplex?venueID=${1}`).then(r => {
          console.log("[COMPLETED SUPERVISOR TASKS FOR THIS VENUE]", r.data)
          r.data.forEach(task => {
            inspectionCompletedCount = inspectionCompletedCount + task.CompletedCount;
          })
          self.NumberOfCompletedTasksPerVenue = inspectionCompletedCount;
          console.log("NUMBER OF TASKS COMPLETED BY THIS VENUE", inspectionCompletedCount)
        })
      }
    }
  }
</script>

<style>
  .card {
    border-radius: 3px;
    background-clip: border-box;
    border: 1px solid rgba(0, 0, 0, 0.125);
    box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.21);
    background-color: transparent;
  }
</style>